export interface IAddress {
  street: string;
  houseNumber: string;
  houseNumberSuffix: string | undefined,
  additionalAddressLine: string | undefined;
  zipCode: string;
  city: string;
}

export class Address implements IAddress {
  street: string = '';
  houseNumber: string = '';
  houseNumberSuffix: string | undefined;
  additionalAddressLine: string | undefined = undefined;
  zipCode: string = '';
  city: string = '';

  static parse(obj: any): Address {
    const address = new Address();
    Object.assign(address, obj);
    return address;
  }
}
